import { render, staticRenderFns } from "./newRoleOccupationPaymentRate.vue?vue&type=template&id=54be96e2&scoped=true&"
import script from "./newRoleOccupationPaymentRate.vue?vue&type=script&lang=js&"
export * from "./newRoleOccupationPaymentRate.vue?vue&type=script&lang=js&"
import style0 from "./newRoleOccupationPaymentRate.vue?vue&type=style&index=0&id=54be96e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be96e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54be96e2')) {
      api.createRecord('54be96e2', component.options)
    } else {
      api.reload('54be96e2', component.options)
    }
    module.hot.accept("./newRoleOccupationPaymentRate.vue?vue&type=template&id=54be96e2&scoped=true&", function () {
      api.rerender('54be96e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/newRoleOccupationPaymentRate.vue"
export default component.exports